import { useEffect, useState } from "react";
import { ArrowRight, Package } from "lucide-react";
import { Reveal, LineReveal } from "@/components/Reveal";
import { getToolkits } from "@/lib/api";

const Toolkits = () => {
  const [toolkits, setToolkits] = useState([]);
  useEffect(() => { getToolkits().then(setToolkits).catch(() => {}); }, []);

  return (
    <div data-testid="toolkits-page">
      <section className="relative pt-40 pb-16 border-b border-forest-700 overflow-hidden grain">
        <img src="/generated/toolkits.png" alt="River stones" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 bg-ink/75" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.3em] text-golden-500 font-semibold mb-6">Digital Products</p>
          <h1 className="font-serif text-white text-5xl md:text-8xl leading-[0.95] tracking-tight">
            <LineReveal lines={["Toolkits &", "Downloads."]} delay={0.2} />
          </h1>
          <p className="text-cream/90 text-lg max-w-xl mt-6">Instant-download tools built on 27 years of Oregon HR experience. Buy once, use forever.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {toolkits.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 0.08}>
              <a href={`/toolkits/${t.id}`} data-testid={`toolkit-card-${t.id}`} className="group flex flex-col h-full bg-forest-900 border border-forest-700 rounded-sm overflow-hidden transition-all duration-300 hover:border-golden-500 hover:-translate-y-1">
                <div className="aspect-[4/3] overflow-hidden relative">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  {t.featured && <span className="absolute top-4 left-4 text-xs uppercase tracking-wider bg-golden-500 text-navy font-semibold px-3 py-1 rounded-sm">Popular</span>}
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-serif text-2xl text-sage-100 mb-2 leading-snug">{t.name}</h3>
                  <p className="text-sage-400 text-sm mb-6 flex-1">{t.tagline}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-golden-500 font-semibold">{t.starting_at}</span>
                    <span className="inline-flex items-center gap-1 text-sm text-sage-200 group-hover:text-golden-500 transition-colors duration-300">View <ArrowRight className="h-4 w-4" /></span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-forest-800/70 border-y border-forest-700 py-16">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <Package className="h-8 w-8 text-golden-500 mx-auto mb-4" />
          <p className="font-serif text-2xl md:text-3xl text-sage-100 max-w-2xl mx-auto">Every toolkit is built and maintained by Susan, drawing on 27 years of HR and Oregon public-sector experience.</p>
        </div>
      </section>
    </div>
  );
};

export default Toolkits;
